import { render, staticRenderFns } from "./HostsConfiguration.vue?vue&type=template&id=05fa24c5&scoped=true&"
import script from "./HostsConfiguration.vue?vue&type=script&lang=ts&"
export * from "./HostsConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./HostsConfiguration.vue?vue&type=style&index=0&id=05fa24c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa24c5",
  null
  
)

export default component.exports